export * from './main.component'